// Index.tsx

import React, { useEffect, useState } from 'react';
import { Typography, Box, Autocomplete, FormControl, FormLabel } from '@mui/material';
import Grid from "@mui/material/Unstable_Grid2";
import Link from 'next/link';
import { useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import SwipeableViews from 'react-swipeable-views';
import NewPlaceClaimForm from '@/components/community/verify-place/FormPlaceClaim';
import WithAuthClientSide from '@/hoc/WithAuthClientSide';
import { Config, isProduction } from '@/config';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { seoConfig } from '@/config/seo.config';
import { MetaTag } from 'next-seo/lib/types';

interface TabPanelProps {
    children?: React.ReactNode;
    dir?: string;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

const CommunityVerifyPlace = () => {
    const theme = useTheme();
    const [value, setValue] = useState(0);
    const [isClient, setIsClient] = useState(false);

    const currentUrl = typeof window !== "undefined" ? window.location.href : `${Config.maaBoom}community/verify-place`;

    // ตรวจสอบว่าอยู่บน client-side
    useEffect(() => {
        setIsClient(true);
    }, []);

    // ฟังก์ชัน handleChange สำหรับ Tabs
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    // ฟังก์ชัน handleChangeIndex สำหรับ Tabs
    const handleChangeIndex = (index: number) => {
        setValue(index);
    };

    if (!isClient) {
        return null;
    }

    return (
        <>
            <NextSeo
                title="ลงทะเบียนธุรกิจ"
                titleTemplate={`%s | ${seoConfig.title}`}
                defaultTitle={seoConfig.defaultTitle}
                description={seoConfig.description}
                canonical={currentUrl}
                openGraph={{
                    ...seoConfig.openGraph,
                    url: currentUrl,
                    title: `ลงทะเบียนธุรกิจ | ${seoConfig.title}`,
                }}
                additionalMetaTags={[
                    ...seoConfig.additionalMetaTags,
                    isProduction ? seoConfig.robots.isProduction : seoConfig.robots.isNotProduction,
                ] as MetaTag[]}
                twitter={seoConfig.twitter}
                facebook={seoConfig.facebook}
            />
            <BreadcrumbJsonLd
            itemListElements={[
                {
                    position: 1,
                    name: 'หน้าแรก',
                    item: 'https://maaboom.com',
                },
                {
                    position: 2,
                    name: 'ลงทะเบียนธุรกิจ',
                    item: currentUrl,
                },
            ]} />
            <Grid container justifyContent="center">
                <Grid xs={12} maxWidth="lg" sx={{ my: 4 }}>
                    <Typography
                        className='txt-title'
                        variant="h1"
                        align="center"
                        gutterBottom
                    >
                        ร่วมลงทะเบียนธุรกิจกับ maaboom
                    </Typography>
                    <Typography
                        className='txt-sub-title'
                        variant="h2"
                        align="center"
                    >
                        <Link href="/community/partner" passHref style={{ textDecoration: 'none', cursor: 'pointer' }}>
                            สร้างเว็บไซต์หน้าร้านได้ง่ายๆ และสิทธิประโยชน์มากมายที่คุณจะได้รับ
                        </Link>
                    </Typography>
                </Grid>
                <Grid xs={12} sm={10} md={10} lg={8} xl={6} sx={{ mb: 4 }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        indicatorColor="secondary"
                        textColor="inherit"
                        aria-label="tab verify place"
                        sx={{
                            backgroundColor: '#ffffff',
                            '& .MuiButtonBase-root': {
                                '&.Mui-selected': {
                                    borderTop: '1px solid rgb(0 0 0 / 12%)', // เส้นขอบด้านบน
                                    borderLeft: '1px solid rgb(0 0 0 / 12%)', // เส้นขอบด้านซ้าย
                                    borderRight: '1px solid rgb(0 0 0 / 12%)', // เส้นขอบด้านขวา
                                    borderRadius: '5px', // มุมโค้งมน
                                },
                            },
                            color: '#292929'
                        }}
                    >
                        <Tab label="ค้นหาธุรกิจและแสดงสิทธิ์" {...a11yProps(0)} />
                        <Tab label="ลงทะเบียนธุรกิจ(ใหม่)" {...a11yProps(1)} />
                    </Tabs>

                    <TabPanel value={value} index={0} dir={theme.direction}>
                        <Grid container justifyContent="center" spacing={0}>
                            <Grid xs={12} mt={2}>
                                <NewPlaceClaimForm valueType={value} />
                            </Grid>
                        </Grid>
                    </TabPanel>
                    <TabPanel value={value} index={1} dir={theme.direction}>
                        <Grid container justifyContent="center" spacing={0}>
                            <Grid xs={12} mt={2}>
                                <NewPlaceClaimForm valueType={value} />
                            </Grid>
                        </Grid>
                    </TabPanel>

                    {/* <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={value}
        onChangeIndex={handleChangeIndex}
    >

    </SwipeableViews> */}
                </Grid>
            </Grid></>
    );
};

export default CommunityVerifyPlace;
